import { arabicCurrencies, arabicSymbols } from '@/src/constants/currency'
import { CURRENCY_LOCALE_MAP, CURRENCY_PRECISION_MAP } from '@/src/constants/domainCurrencyMap'
import { formatCurrency } from '@/src/utils/currency/formatCurrency'
import { useLocale } from 'next-intl'

const useFormatCurrency = () => {
    const language = useLocale()

    const formatCurrencyValue = ({
        toCurrency,
        rate,
        buffer,
        price,
        usePrecision
    }: {
        toCurrency: string
        rate: number
        buffer: number
        price: number
        usePrecision?: boolean
    }) => {
        const convertedAmount = price * (rate + (rate * buffer) / 100)
        const precision = CURRENCY_PRECISION_MAP[toCurrency] || 0

        const convertToArabic = toCurrency === 'SAR' || (language === 'ar' && arabicCurrencies.includes(toCurrency))
        const locale = convertToArabic ? 'en-US' : CURRENCY_LOCALE_MAP[toCurrency] || 'en-US'
        const formattedPrice = formatCurrency({
            amount: convertedAmount,
            currency: toCurrency,
            locale,
            precision,
            usePrecision
        })

        // For Arabic language, we need special handling to keep English numerals but position symbol correctly
        if (convertToArabic) {
            // Remove the currency code and format for RTL
            const numberPart = formattedPrice.replace(/[A-Z]{3}/g, '').trim()
            const arabicSymbol = arabicSymbols[toCurrency as keyof typeof arabicSymbols]

            // For RTL, put the number first, then the symbol
            if (language === 'ar') {
                return `${numberPart} ${arabicSymbol}`
            }
            return `${arabicSymbol} ${numberPart}`
        }

        // Use standard locale mapping for non-Arabic or other currencies

        return formattedPrice
    }

    return {
        formatCurrency: formatCurrencyValue
    }
}

export default useFormatCurrency
